import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { agentLabel, isLocalIp, upperFirst } from '../utils/kernelDevice';
import { fmtDateTime } from '../utils/kernelFormat';
import './kernelSessions.css';

const REASONS = ['limit', 'user', 'password', 'admin', 'logout', 'expired'];

/**
 * Avviso sulla pagina di login quando l'utente è stato disconnesso: dice perché e, se è stato un altro accesso (o un
 * cambio password), da quale dispositivo, indirizzo e a che ora. `notice` è la risposta del server alla richiesta
 * respinta (`reason`, `at`, `by_ip`, `by_agent`), conservata da utils/kernelDevice.saveSessionNotice.
 */
function KernelSessionNotice({ notice }) {
  const { t } = useLanguage();
  if (!notice) return null;
  const reason = REASONS.includes(notice.reason) ? notice.reason : 'unknown';

  const parts = [];
  const device = agentLabel(notice.by_agent);
  if (device) parts.push(device);
  if (notice.by_ip) parts.push(`${t('sessionNotice.address')} ${isLocalIp(notice.by_ip) ? upperFirst(t('sessions.localIp')) : notice.by_ip}`);
  if (notice.at) parts.push(fmtDateTime(notice.at));
  const who = parts.length > 0 && ['limit', 'user', 'password'].includes(reason) ? ` (${parts.join(', ')})` : '';

  return (
    <div className="session-notice" role="alert">
      <strong>{t('sessionNotice.title')}</strong>
      <span>{t(`sessionNotice.${reason}`, { who })}</span>
    </div>
  );
}

export default KernelSessionNotice;
